import { useEffect, useReducer, useState } from 'react';
import { HubConnection, LogLevel } from '@microsoft/signalr';
import {signalRConnectionReducer} from '../store/signalR-connection';
import {SignalRConnections} from "@shared/types";
import { refreshAccessToken } from '@shared/services/api';
import { useSelector } from 'react-redux';
import { selectAccessToken } from '@shared/store/app-user/appuser.selectors';
import RealTimeConnectionLogger from '@shared/websockets/real-time-connection-logger';

const initial: SignalRConnections = {};

export function useSignalRConnection(createConnection: () => HubConnection): SignalRConnections {
  const [state, setState] = useReducer(signalRConnectionReducer, initial);
  const token = useSelector(selectAccessToken);
  const [accessToken, setAccessToken] = useState(token);
  const realtimeConnectionLogger = new RealTimeConnectionLogger();

  useEffect(() => {
    const connection = createConnection();
    connection
      .start()
      .then(() => setState({connection}))
      .catch(async error => {
        if (error.statusCode === 401) {
          connection.stop().then();
          const token = await refreshAccessToken()
          setAccessToken(token);
        }
        realtimeConnectionLogger.log(LogLevel.Error, `Connection to SmsIncoming failed: ${error}.`);
      })

    return () => {
      connection.stop();
    };
  }, [createConnection, setState, accessToken]);

  return state; 
}

